import { routes } from '@/constants/Constants';

export const applicationTrackerNavigation = {
  overviewPath: routes.dealsDashboard,
  renewalCollectPath: routes.renewalIntentCollect,
} as const;
